var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2761 64.3496C29.2761 67.111 31.5147 69.3496 34.2761 69.3496H34.9304C37.6918 69.3496 39.9304 67.111 39.9304 64.3496V44.4179C39.9304 42.2088 41.7212 40.4179 43.9304 40.4179H63.8613C66.6227 40.4179 68.8613 38.1794 68.8613 35.4179V34.7637C68.8613 32.0023 66.6227 29.7637 63.8613 29.7637H43.9304C41.7212 29.7637 39.9304 27.9728 39.9304 25.7637V5.83203C39.9304 3.07061 37.6918 0.832031 34.9304 0.832031H34.2761C31.5147 0.832031 29.2761 3.07061 29.2761 5.83203V25.7637C29.2761 27.9728 27.4853 29.7637 25.2761 29.7637H5.34375C2.58233 29.7637 0.34375 32.0023 0.34375 34.7637V35.4179C0.34375 38.1794 2.58233 40.4179 5.34375 40.4179H25.2761C27.4853 40.4179 29.2761 42.2088 29.2761 44.4179V64.3496Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.c1c533267685aa65e68f88498a179bc0.svg";
export { ForwardRef as ReactComponent };